/* Склад набору — показуємо лише обраний розмір.

   Метаполе custom.bundle_contents віддає плаский список:
     <h6>Розмір S</h6><ul>…</ul><h6>Розмір M</h6><ul>…</ul><p>примітка</p><p>примітка</p>

   Скрипт групує заголовок разом із його списком і лишає видимою тільки ту
   групу, що відповідає вибраному розміру. Абзаци-примітки в кінці видно завжди.

   Працює і на сторінці товару, і у вспливаючому вікні швидкого перегляду.
   Діє лише всередині блоків, де є заголовки «Розмір …» — інші акордеони
   теми не зачіпає, тож підключати його можна глобально. */

(function () {
  var SIZE_OPTION = /размер|розмір|size/i;

  /* Шукаємо самі заголовки «Розмір …» і беремо їхнього батька, яким би він не був.
     Раніше перевірявся перший заголовок у блоці, а ним виявився заголовок
     самої вкладки — через це контейнер не знаходився. */
  function findContainers() {
    var out = [];
    document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (h) {
      if (!/^\s*Розмір\s/.test(h.textContent)) return;
      var parent = h.parentElement;
      if (parent && out.indexOf(parent) === -1) out.push(parent);
    });
    return out;
  }

  /* Межі пошуку: у вспливаючому вікні читаємо розмір саме з нього,
     інакше підхопимо перемикач сторінки, яка лишилась під модалкою. */
  function scopeOf(el) {
    return el.closest('#product-modal-content, .product-quick-view-content, #product-modal, .product, main') || document;
  }

  /* поточний розмір: спершу з відмітки в перемикачі, далі з підпису «Размер: M» */
  function currentSize(scope) {
    scope = scope || document;
    var checked = scope.querySelectorAll('input[type="radio"]:checked, select');
    for (var i = 0; i < checked.length; i++) {
      var el = checked[i];
      var name = el.getAttribute('name') || '';
      if (SIZE_OPTION.test(name)) return (el.value || '').trim();
    }
    var label = scope.querySelector('[data-selected-swatch-value], .form__label');
    if (label && SIZE_OPTION.test(label.textContent)) {
      var parts = label.textContent.split(':');
      if (parts.length > 1) return parts[1].trim();
    }
    return null;
  }

  function build(container) {
    var kids = Array.prototype.slice.call(container.children);
    var lastList = -1;
    kids.forEach(function (el, i) {
      if (el.tagName === 'UL' || el.tagName === 'OL') lastList = i;
    });

    var groups = [];
    var current = null;
    kids.forEach(function (el, i) {
      if (i > lastList) return;                       /* примітки в кінці — не чіпаємо */
      if (/^H[1-6]$/.test(el.tagName) && /^\s*Розмір\s/.test(el.textContent)) {
        current = { size: el.textContent.replace(/^\s*Розмір\s+/, '').trim(), nodes: [el] };
        groups.push(current);
      } else if (current) {
        current.nodes.push(el);
      }
    });
    return groups;
  }

  function apply(container, groups) {
    var size = currentSize(scopeOf(container));
    var shown = false;
    groups.forEach(function (g) {
      var match = size && g.size.toLowerCase() === size.toLowerCase();
      g.nodes.forEach(function (n) { n.style.display = match ? '' : 'none'; });
      /* верхній відступ у теми знімається лише з першого заголовка в блоці;
         щойно ми ховаємо попередні групи, він проявляється — прибираємо вручну */
      g.nodes[0].style.marginTop = match ? '0' : '';
      if (match) shown = true;
    });
    /* розмір не впізнали — краще показати все, ніж порожню вкладку */
    if (!shown) {
      groups.forEach(function (g, i) {
        g.nodes.forEach(function (n) { n.style.display = ''; });
        g.nodes[0].style.marginTop = i === 0 ? '0' : '';
      });
    }
  }

  function refresh() {
    findContainers().forEach(function (c) {
      var groups = build(c);
      if (groups.length) apply(c, groups);
    });
  }

  function init() {
    refresh();

    document.addEventListener('change', function (e) {
      var n = e.target && (e.target.getAttribute('name') || '');
      if (SIZE_OPTION.test(n)) setTimeout(refresh, 60);
    });
    document.addEventListener('variant:change', function () { setTimeout(refresh, 60); });
    window.addEventListener('popstate', function () { setTimeout(refresh, 120); });

    /* вміст швидкого перегляду підвантажується вже після завантаження сторінки */
    var modal = document.getElementById('product-modal-content') || document.body;
    new MutationObserver(function () { setTimeout(refresh, 40); })
      .observe(modal, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
